import React, { useState, useEffect, Fragment, useMemo } from "react"
import { useSelector, useDispatch } from "react-redux"
import { withStyles } from "@material-ui/core/styles"
import styles from "./styles"
import {
  TextField,
  Switch,
  Typography,
  CardHeader,
  Avatar,
  FormGroup,
  FormControl,
  FormControlLabel,
  Box,
  Checkbox,
  IconButton,
  Button,
  CircularProgress,
  Grid,
  Collapse,
  Tooltip
} from "@material-ui/core/"
import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,
  KeyboardDatePicker
} from "@material-ui/pickers"
import MomentUtils from "@date-io/moment"
import RadioUncheckedIcon from "@material-ui/icons/RadioButtonUnchecked"
import RadioCheckedIcon from "@material-ui/icons/RadioButtonChecked"
import YouTubeIcon from "@material-ui/icons/YouTube"
import FacebookIcon from "@material-ui/icons/Facebook"
import LinkedinIcon from "@material-ui/icons/LinkedIn"
import TwitterIcon from "@material-ui/icons/Twitter"
import Hootsuite from "assets/hootsuite-icon.svg"
import TweetDeck from "assets/tweet-deck-icon.svg"
import cloudinary from "cloudinary-core"
import GooglePlacesAutocomplete from "react-google-places-autocomplete"
import CropIcon from "@material-ui/icons/Crop"
import { openCropDialogDialog } from "actions/crop-dialog-dialog"
import { checkSocialTokens } from "actions/organization"
import RepeatIcon from "@material-ui/icons/Repeat"
import { handleConnect } from "utils/handleSocialConnect"
import moment from "moment"
const cl = new cloudinary.Cloudinary({
  cloud_name: process.env.REACT_APP_CLOUD_NAME
})

const getNetworks = classes => [
  {
    name: "YouTube",
    icon: <YouTubeIcon fontSize="large" className={classes.iconColor} />
  },
  {
    name: "Twitter",
    icon: <TwitterIcon fontSize="large" className={classes.iconColor} />
  },
  {
    name: "Facebook",
    icon: <FacebookIcon fontSize="large" className={classes.iconColor} />
  },
  {
    name: "LinkedIn",
    icon: <LinkedinIcon fontSize="large" className={classes.iconColor} />
  },
  {
    name: "Hootsuite",
    icon: (
      <img
        src={Hootsuite}
        key={5}
        alt="hootsuite-icon"
        className={classes.icon}
      />
    )
  }
  // {
  //   name: "TweetDeck",
  //   icon: (
  //     <img
  //       src={TweetDeck}
  //       key={5}
  //       alt="TweetDeck"
  //       className={`${classes.icon} ${classes.tweetDeckIcon}`}
  //     />
  //   )
  // }
]

const PublishPost = ({
  classes,
  data,
  setPostBody,
  // setPostImage,
  setPostLocation,
  setPostNetworks,
  setSelectedDate,
  setSelectedLinkedinOrgs,
  selectedLinkedinOrgs,
  setSelectedFacebookOrgs,
  selectedFacebookOrgs,
  postBody,
  postImage,
  postLocation,
  postNetworks,
  selectedDate,
  crop,
  onCropChange,
  useEmail,
  setUseEmail,
  setUseShare,
  useShare,
  emailsWithTags,
  tags,
  source,
  uploadType,
  setSource,
  setUploadType,
  setDownloadSource,
  setVideoImage,
  setHasErrors,
  hasErrors,
  working
}) => {
  const dispatch = useDispatch()
  const orgNetworks = useSelector(state => [
    state.organization.currentOrg.twitter ? "Twitter" : null,
    state.organization.currentOrg.twitter ? "TweetDeck" : null,
    state.organization.currentOrg.facebook ? "Facebook" : null,
    state.organization.currentOrg.linkedin ? "LinkedIn" : null,
    state.organization.currentOrg.youtube ? "YouTube" : null,
    state.organization.currentOrg.hootsuite ? "Hootsuite" : null
  ])
  const orgNetworksWithVideo = [
    "Facebook",
    "Hootsuite",
    "Twitter",
    "LinkedIn",
    "TweetDeck",
    "YouTube"
  ]

  const { id } = useSelector(state => state.organization.currentOrg)

  // const [useLocation, setUseLocation] = useState(data.useLocation)
  const [socialLoading, setSocialLoading] = useState(false)
  const [socialVerified, setSocialVerified] = useState({})
  const [facebookHasNoPages, setFacebookHasNoPages] = useState(false)
  const [linkedinOrgs, setLinkedinOrgs] = useState([])
  const [facebookOrgs, setFacebookOrgs] = useState([])
  const [twitterCharacters, setTwitterCharacters] = useState()

  const handleChangeCheckbox = network => {
    setPostNetworks(
      postNetworks.includes(network)
        ? postNetworks.filter(element => element !== network)
        : [...postNetworks, network]
    )
  }

  useEffect(() => {
    if (postBody) {
      if (postBody.length > 280) {
        setHasErrors(errors => ({
          ...errors,
          Twitter: {
            error: true,
            message: "The description is over the character limit for Twitter."
          }
        }))
      }
      if (
        hasErrors.Twitter &&
        hasErrors.Twitter.error &&
        postBody.length <= 280
      ) {
        setHasErrors(errors => ({
          ...errors,
          Twitter: { error: false, message: "" }
        }))
      }

      setTwitterCharacters(`${postBody.length} /280`)
    }
  }, [postBody])

  const handleDateChange = date => {
    setSelectedDate(moment.utc(date).format())
  }

  const handleOrgChange = (org, event) => {
    if (event.target.checked) {
      selectedLinkedinOrgs.push(org)
    } else {
      selectedLinkedinOrgs.splice(selectedLinkedinOrgs.indexOf(org), 1)
    }
    setSelectedLinkedinOrgs([...new Set(selectedLinkedinOrgs)])
  }

  const handleFacebookOrgChange = (org, event) => {
    if (event.target.checked) {
      selectedFacebookOrgs.push(org)
    } else {
      selectedFacebookOrgs.splice(selectedFacebookOrgs.indexOf(org), 1)
    }
    setSelectedFacebookOrgs([...new Set(selectedFacebookOrgs)])
  }

  useEffect(() => {
    setSocialLoading(true)
    dispatch(checkSocialTokens())
      .then(res => {
        const responseArray = res.data
        let socialVerified = {}

        // Create object with verified social tokens true/false with server response
        responseArray.map(social => {
          const key = Object.keys(social)
          // Check for facebook pages
          if (key[0] === "facebook" && social[key].message === "No pages.") {
            setFacebookHasNoPages(true)
          }

          socialVerified = {
            ...socialVerified,
            [key]: social[key].verified
          }

          if (key[0] === "linkedin" && social[key].orgs) {
            setLinkedinOrgs(social[key].orgs)
          }
          if (key[0] === "facebook") {
            setFacebookOrgs(social[key].pages)
          }
        })

        setSocialVerified(socialVerified)
        setSocialLoading(false)
      })
      .catch(error => {
        console.log({ error })
      })
  }, [])

  let title
  let subTitle
  let avatar
  if (data.originally_posted) {
    title = data.originally_posted
    subTitle = `${data.first_name} ${data.last_name}`
    avatar = data.originally_posted_logo
  } else {
    title = `${data.first_name} ${data.last_name}`
    subTitle = data.title_value && data.title_value
    avatar = data.profile_image
  }

  useEffect(() => {
    const fileObj = postImage
    if (fileObj.resource_type === "video") {
      setSource(
        cl.video_url(fileObj.public_id, {
          crop: "fill",
          quality: 75,
          fetch_format: "mp4",
          height: 720,
          width: 1280
        })
      )
      setVideoImage(
        cl.video_url(`${fileObj.public_id}.jpg`, {
          startOffset: "1"
        })
      )
      setDownloadSource(cl.video_url(`${fileObj.public_id}`, {}))
    } else {
      if (!working) {
        if (crop && Object.keys(crop).length > 0) {
          const scaleX = crop.imageNaturalWidth / crop.imageWidth
          const scaleY = crop.imageNaturalHeight / crop.imageHeight

          setSource(
            cl.url(fileObj.public_id, {
              width: (crop.width * scaleX).toFixed(0),
              height: (crop.height * scaleY).toFixed(0),
              x: (crop.x * scaleX).toFixed(0),
              y: (crop.y * scaleY).toFixed(0),
              crop: "crop"
            })
          )
          setDownloadSource(cl.url(fileObj.public_id, { flags: "attachment" }))
        } else {
          setSource(cl.url(fileObj.public_id))
          setDownloadSource(cl.video_url(`${fileObj.public_id}`, {}))
        }
      }
    }
  }, [postImage, crop])

  return (
    <Box display="flex" className={classes.postContainer}>
      <Box className={classes.leftContainer}>
        <Box className={classes.personContainer}>
          <div className={classes.media}>
            {uploadType && uploadType === "image" && (
              <Fragment>
                <img src={source} className={classes.image} />
                {/* <IconButton
                  className={classes.cropButton}
                  onClick={() =>
                    dispatch(openCropDialogDialog({ image: postImage }))
                      .then(res => {
                        onCropChange(res)
                      })
                      .catch(err => {
                        onCropChange({})
                      })
                  }
                  aria-label="crop"
                >
                  <CropIcon />
                </IconButton> */}
              </Fragment>
            )}
            {uploadType && uploadType === "video" && (
              <video
                controls
                className={classes.video}
                playsInline="playsinline"
                src={`${source}.mp4`}
              />
            )}
            {/* {crop && Object.keys(crop).length > 0 && (
              <Button
                size="large"
                className={classes.cropActionButton}
                variant="contained"
                color="primary"
                onClick={() =>
                  dispatch(openCropDialogDialog({ image: postImage }))
                    .then(res => {
                      onCropChange(res)
                    })
                    .catch(err => {
                      onCropChange({})
                    })
                }
              >
                Recrop
              </Button>
            )} */}
          </div>
          <Box className={classes.avatarContainer}>
            <CardHeader
              avatar={
                <Avatar
                  alt="Member"
                  src={
                    avatar &&
                    cl.url(JSON.parse(avatar).public_id, {
                      width: 150,
                      crop: "scale"
                    })
                  }
                />
              }
              title={title}
              subheader={subTitle}
            />
          </Box>
        </Box>
      </Box>
      <Box className={classes.rightContainer}>
        <Box display="flex">
          <TextField
            InputProps={{
              classes: { underline: classes.underline }
            }}
            // classes={{ underline: classes.underline }}
            className={classes.textFieldContainer}
            multiline
            rows="6"
            variant="filled"
            defaultValue={postBody}
            inputProps={{
              className: classes.textArea
              // underline: classes.underline
            }}
            onChange={e => {
              setPostBody(e.target.value)
            }}
          />
        </Box>
        {/* <Box display="flex" justifyContent="flex-end">
          {postBody && postBody.length}
        </Box>
        <Box display="flex" justifyContent="flex-start" alignItems="center">
          <Switch
            checked={Boolean(useLocation)}
            color="primary"
            inputProps={{ "aria-label": "disabled checkbox" }}
            onChange={() => {
              setUseLocation(!useLocation)
            }}
          />

          <Typography className={classes.switchText}>
            Use geolocation
          </Typography>
        </Box>
        <GooglePlacesAutocomplete
          placeholder=""
          suggestionsClassNames={{
            container: classes.locationSuggestionContainer,
            suggestion: classes.locationSuggestion,
            suggestionActive: classes.locationSuggestionActive
          }}
          loader={<div style={{ display: "none" }} />}
          onSelect={place => {
            setPostLocation(place.description)
          }}
          renderInput={props => {
            // props.defaultValue = undefined
            return (
              <TextField
                label="Location"
                onKeyUp={e => {
                  setPostLocation(e.target.value)
                }}
                {...props}
                onChange={e => {
                  props.onChange(e)
                  setPostLocation(e.target.value)
                }}
                value={postLocation}
                disabled={Boolean(useLocation)}
              />
            )
          }}
        /> */}
        {socialLoading ? (
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            height="100px"
          >
            <CircularProgress
              sytle={{ width: "24px" }}
              classes={{ colorPrimary: classes.spinnerColor }}
            />
          </Box>
        ) : (
          <FormControl component="fieldset">
            <Typography variant="body1" className={classes.legend}>
              Include Networks
            </Typography>
            {Object.values(socialVerified).indexOf(false) > -1 && (
              <Typography className={classes.reconnect}>
                One or more of your social networks need to be reconnected.
              </Typography>
            )}
            {orgNetworks.includes("Twitter") && postImage.duration > 30 && (
              <Typography className={classes.reconnect}>
                Video is required to be 30 seconds or less to post to Twitter.
              </Typography>
            )}
            {facebookHasNoPages && (
              <Typography className={classes.reconnect}>
                You currently don't have any Facebook pages selected. Please
                reconnect to Facebook and select at least one page you have
                posting permissions to.
              </Typography>
            )}
            {hasErrors &&
              Object.keys(hasErrors).map(key => {
                if (hasErrors[key].error && postNetworks.includes(key)) {
                  return (
                    <Typography className={classes.reconnect}>
                      {hasErrors[key].message}
                    </Typography>
                  )
                }
              })}
            <Box
              display="flex"
              flexWrap="wrap"
              className={classes.networksContainer}
            >
              {uploadType === "image" &&
                getNetworks(classes).map((network, i) => {
                  return (
                    orgNetworks.includes(network.name) &&
                    network.name !== "YouTube" && (
                      <Box
                        key={i}
                        display="flex"
                        alignItems="flex-start"
                        className={classes.networkContainer}
                      >
                        <FormControlLabel
                          classes={{ root: classes.labelMargin }}
                          control={
                            <Fragment>
                              {socialVerified[network.name.toLowerCase()] ? (
                                <Checkbox
                                  className={classes.checkboxContainer}
                                  checked={postNetworks.includes(network.name)}
                                  icon={<RadioUncheckedIcon />}
                                  checkedIcon={<RadioCheckedIcon />}
                                  color="primary"
                                  value={network.name}
                                  onChange={() =>
                                    handleChangeCheckbox(network.name)
                                  }
                                />
                              ) : (
                                <Tooltip title="Reconnect">
                                  <Button
                                    className={classes.connectButton}
                                    onClick={() =>
                                      handleConnect(network.name, id)
                                    }
                                  >
                                    <RepeatIcon
                                      color="primary"
                                      className={classes.repeatIcon}
                                    />
                                  </Button>
                                </Tooltip>
                              )}
                            </Fragment>
                          }
                        />
                        <Box display="flex" flexDirection="column">
                          {network.icon}
                          {network.name === "Twitter" && (
                            <Box className={classes.twitterCharactersCounter}>
                              <Typography
                                className={
                                  postBody && postBody.length <= 280
                                    ? classes.greenCharacter
                                    : classes.redCharacter
                                }
                              >
                                {twitterCharacters}
                              </Typography>
                            </Box>
                          )}
                        </Box>
                      </Box>
                    )
                  )
                })}
              {uploadType === "video" &&
                getNetworks(classes).map((network, i) => {
                  return (
                    orgNetworksWithVideo.includes(network.name) && (
                      <Box
                        key={i}
                        display="flex"
                        alignItems="flex-start"
                        className={classes.networkContainer}
                      >
                        <FormControlLabel
                          control={
                            <Box>
                              <Fragment>
                                {socialVerified[network.name.toLowerCase()] ? (
                                  <Checkbox
                                    className={classes.checkboxContainer}
                                    checked={postNetworks.includes(
                                      network.name
                                    )}
                                    icon={<RadioUncheckedIcon />}
                                    checkedIcon={<RadioCheckedIcon />}
                                    color="primary"
                                    value={network.name}
                                    disabled={Boolean(
                                      network.name === "Twitter" &&
                                        postImage.duration > 30
                                      // || (network.name === "TweetDeck" &&
                                      //   postImage.duration > 30)
                                    )}
                                    onChange={() =>
                                      handleChangeCheckbox(network.name)
                                    }
                                  />
                                ) : (
                                  <Button
                                    className={classes.connectButton}
                                    onClick={() =>
                                      handleConnect(network.name, id)
                                    }
                                  >
                                    <RepeatIcon
                                      color="primary"
                                      className={classes.repeatIcon}
                                    />
                                  </Button>
                                )}
                              </Fragment>
                            </Box>
                          }
                        />
                        <Box display="flex" flexDirection="column">
                          {network.icon}
                          {network.name === "Twitter" && (
                            <Box className={classes.twitterCharactersCounter}>
                              <Typography
                                className={
                                  postBody && postBody.length <= 280
                                    ? classes.greenCharacter
                                    : classes.redCharacter
                                }
                              >
                                {twitterCharacters}
                              </Typography>
                            </Box>
                          )}
                        </Box>
                      </Box>
                    )
                  )
                })}
              <Collapse
                in={
                  Boolean(postNetworks.includes("Hootsuite")) ||
                  Boolean(postNetworks.includes("TweetDeck"))
                }
              >
                <Grid container justify="space-around">
                  <MuiPickersUtilsProvider utils={MomentUtils}>
                    <KeyboardDatePicker
                      className={classes.keyboardPicker}
                      margin="normal"
                      id="date-picker-dialog"
                      label="Publish Date"
                      format="MM/DD/yyyy"
                      minDate={moment
                        .utc(new Date())
                        .add(1, "days")
                        .format()}
                      maxDate={moment
                        .utc(new Date())
                        .add(12, "months")
                        .format()}
                      value={selectedDate}
                      minDateMessage="Date must be after today"
                      maxDateMessage="Exceeds 12 months"
                      onChange={handleDateChange}
                      KeyboardButtonProps={{
                        "aria-label": "change date"
                      }}
                    />
                    <KeyboardTimePicker
                      className={classes.keyboardPicker}
                      margin="normal"
                      id="time-picker"
                      label="Publish Time"
                      value={selectedDate}
                      onChange={handleDateChange}
                      KeyboardButtonProps={{
                        "aria-label": "change time"
                      }}
                    />
                  </MuiPickersUtilsProvider>
                </Grid>
              </Collapse>
              {
                <Collapse
                  className={classes.linkedinCollapse}
                  in={Boolean(postNetworks.includes("LinkedIn"))}
                >
                  <Typography variant="body1" className={classes.legend}>
                    LinkedIn Organizations
                  </Typography>
                  <Grid container justify="space-between">
                    {linkedinOrgs.map((org, i) => {
                      const organization = org["organization~"]

                      organization.urn = org.organization

                      return (
                        <Grid key={i} item xs={12} md={6}>
                          <FormControlLabel
                            className={classes.linkedinOrgLabel}
                            control={
                              <Checkbox
                                checked={selectedLinkedinOrgs
                                  .map(x => x.localizedName)
                                  .includes(organization.localizedName)}
                                className={classes.checkboxContainer}
                                icon={<RadioUncheckedIcon />}
                                checkedIcon={<RadioCheckedIcon />}
                                color="primary"
                                value={{ organization }}
                                onChange={event =>
                                  handleOrgChange(organization, event)
                                }
                              />
                            }
                            label={organization.localizedName}
                          />
                        </Grid>
                      )
                    })}
                  </Grid>
                </Collapse>
              }
              {
                <Collapse
                  className={classes.linkedinCollapse}
                  in={Boolean(postNetworks.includes("Facebook"))}
                >
                  <Typography variant="body1" className={classes.legend}>
                    Facebook Pages
                  </Typography>
                  <Grid container justify="space-between">
                    {facebookOrgs.map((org, i) => {
                      // const organization = org["organization~"]
                      // organization.urn = org.organization

                      return (
                        <Grid key={i} item xs={12} md={6}>
                          <FormControlLabel
                            className={classes.linkedinOrgLabel}
                            control={
                              <Checkbox
                                checked={selectedFacebookOrgs
                                  .map(x => x.name)
                                  .includes(org.name)}
                                className={classes.checkboxContainer}
                                icon={<RadioUncheckedIcon />}
                                checkedIcon={<RadioCheckedIcon />}
                                color="primary"
                                value={org.name}
                                onChange={event =>
                                  handleFacebookOrgChange(org, event)
                                }
                              />
                            }
                            label={org.name}
                          />
                        </Grid>
                      )
                    })}
                  </Grid>
                </Collapse>
              }
            </Box>
          </FormControl>
        )}
        <Typography variant="body1" className={classes.legend}>
          Additional Options
        </Typography>
        <Box display="flex" alignItems="flex-start">
          <Box display="flex" style={{ width: "50%" }}>
            <Switch
              color="primary"
              checked={Boolean(useEmail)}
              // classes={
              //   useEmail ? { thumb: classes.thumb, track: classes.track } : null
              // }
              inputProps={{ "aria-label": "disabled checkbox" }}
              onChange={() => {
                setUseEmail(!useEmail)
              }}
            />
            <Box>
              <Typography className={classes.optionsTitle}>Email</Typography>
              <Typography
                variant="subtitle1"
                className={classes.optionsSubtitle}
              >
                Can share with members on an email
              </Typography>
            </Box>
          </Box>
          <Box display="flex" style={{ width: "50%" }}>
            <Switch
              color="primary"
              // classes={
              //   useShare ? { thumb: classes.thumb, track: classes.track } : null
              // }
              checked={Boolean(useShare)}
              inputProps={{ "aria-label": "disabled checkbox" }}
              onChange={() => {
                setUseShare(!useShare)
              }}
            />
            <Box>
              <Typography className={classes.optionsTitle}>Share</Typography>
              <Typography
                className={classes.optionsSubtitle}
                variant="subtitle1"
              >
                Can share with other FirstLine Account
              </Typography>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

export default withStyles(styles)(PublishPost)



// WEBPACK FOOTER //
// ./src/dialogs/PublishContainer/steps/PublishPost/index.jsx